var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "vfbSelect"
  }, [_c('el-select', {
    staticClass: "outputType",
    attrs: {
      "placeholder": "Type",
      "popper-class": "interviewMainWindow"
    },
    on: {
      "change": _vm.changeMainWindowType
    },
    model: {
      value: _vm.selectOutputType,
      callback: function ($$v) {
        _vm.selectOutputType = $$v;
      },
      expression: "selectOutputType"
    }
  }, _vm._l(_vm.mainWindowList, function (item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": _vm.$t(`addTvuOne.${item.label}`),
        "value": item.value
      }
    });
  }), 1), _c('el-select', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: _vm.listScroll,
      expression: "listScroll"
    }],
    ref: "selectBox",
    staticClass: "selectBox m_r_5",
    attrs: {
      "visible-arrow": false,
      "placeholder": "Select source",
      "no-data-text": _vm.returnNoData,
      "no-match-text": _vm.returnNoData,
      "popper-class": "vfbPop",
      "filterable": "",
      "filter-method": val => {
        _vm.getOutputList('filter', '', val);
      }
    },
    on: {
      "focus": _vm.setOptionWidth,
      "visible-change": val => {
        if (val) _vm.getOutputList('getDeviceList', 'visiable', val);
      }
    },
    model: {
      value: _vm.selectOutput,
      callback: function ($$v) {
        _vm.selectOutput = $$v;
      },
      expression: "selectOutput"
    }
  }, _vm._l(_vm.outputList, function (item) {
    return _c('el-option', {
      key: item.mainwindowId,
      attrs: {
        "label": item.name || item.sourceName || item.channelName || item.objectName,
        "value": item.mainwindowId
      }
    }, [_c('el-tooltip', {
      attrs: {
        "content": item.name || item.sourceName || item.channelName || item.objectName,
        "placement": "top-start",
        "effect": "dark",
        "popper-class": "custom-tooltip"
      }
    }, [_c('div', {
      on: {
        "click": function ($event) {
          return _vm.showVfbDialog(item);
        }
      }
    }, [_c('p', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name || item.sourceName || item.channelName || item.objectName))])])])], 1);
  }), 1), _c('el-button', {
    staticClass: "outputBtn",
    class: {
      grays: _vm.sendBtnColor == 'gray',
      'green-gradient': _vm.sendBtnColor == 'green',
      'red-gradient': _vm.sendBtnColor == 'red'
    },
    attrs: {
      "disabled": _vm.sendBtnColor == 'gray',
      "loading": _vm.liveLoading
    },
    on: {
      "click": _vm.controlOutput
    }
  }, [_vm._v(" " + _vm._s(_vm.sendBtnColor == 'red' ? _vm.$t('galleryHost.stop') : _vm.$t('galleryHost.send')) + " ")]), _vm.sourceVfbType.show ? _c('select-source-type', {
    attrs: {
      "info": _vm.sourceVfbType,
      "sendReceiverInfo": _vm.sendReceiverInfo,
      "loadingBtn": _vm.liveLoading,
      "appendToBody": true,
      "showAudioHtml": true,
      "pageNum": _vm.pageNum
    },
    on: {
      "updateVfbData": _vm.updateVfbData
    }
  }) : _vm._e(), _vm.encoderInfo.visible ? _c('EncoderInfo', {
    attrs: {
      "info": _vm.encoderInfo,
      "appendToBody": true
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };